//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 17.10.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngTableColumnIpAddressFilter', srsngTableColumnIpAddressFilter);

    function srsngTableColumnIpAddressFilter() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/mega-table/filter/ip-address/ip-address.html',
            scope: {
                data: '='
            },
            controller: controller,
            link: link
        };

        function controller($scope) {

            $scope.sort = direction => {

                $scope.filter();
            };

            $scope.search = () => {

                $scope.filter();
            };

            $scope.filter = () => {
                $scope.data.callback($scope.data);
            };

            $scope.reset = () => {

                setIpAddress($scope.data.singleIpAddress, null);
                setIpAddress($scope.data.fromIpAddress, null);
                setIpAddress($scope.data.toIpAddress, null);
                $scope.data.ipAddressFilterType = 'none';
                $scope.filter();
            };

            $scope.updateFilterType = () => {

                $scope.filter();
            };

            init();

            function init() {

                if ($scope.data.searchText == null)
                    $scope.data.searchText = '';

                if ($scope.data.ipAddressFilterType == null)
                    $scope.data.ipAddressFilterType = 'none';

                if ($scope.data.singleIpAddress == null) {

                    $scope.data.singleIpAddress = {
                        name: 'single',
                        label: 'Single'
                    };

                    setIpAddress($scope.data.singleIpAddress, null);
                }

                $scope.$watch('data.singleIpAddress.value', newValue => {
                    setIpAddress($scope.data.singleIpAddress, newValue);
                    $scope.filter();
                });

                if ($scope.data.fromIpAddress == null) {

                    $scope.data.fromIpAddress = {
                        name: 'from',
                        label: 'From'
                    };

                    setIpAddress($scope.data.fromIpAddress, null);
                }

                $scope.$watch('data.fromIpAddress.value', newValue => {
                    setIpAddress($scope.data.fromIpAddress, newValue);
                    $scope.filter();
                });

                if ($scope.data.toIpAddress == null) {

                    $scope.data.toIpAddress = {
                        name: 'to',
                        label: 'To'
                    };

                    setIpAddress($scope.data.toIpAddress, null);
                }

                $scope.$watch('data.toIpAddress.value', newValue => {
                    setIpAddress($scope.data.toIpAddress, newValue);
                    $scope.filter();
                });
            }

            function setIpAddress(ipAddress, value) {
                ipAddress.value = value || '';
                ipAddress.octets = getOctets(ipAddress.value);
            }

            function getOctets(ipAddressValue) {
                return ipAddressValue.split('.').map(octet => parseInt(octet, 10));
            }
        }

        function link(scope, element, attrs) {

            element.on('$destroy', function () {
                scope.$evalAsync(function () {
                    scope.$destroy();
                });
            });
        }
    }
})();
